class TermsConditions extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    this.innerHTML = `
      <article class="public-page" aria-label="Terms and Conditions">
        <header>
          <p>Short, friendly, and still legally useful.</p>
          <h1>Terms & Conditions</h1>
          <p>Last updated: ${new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
        </header>

        <section>
          <h2>1. The vibe</h2>
          <p>Fun Old Times is a friends-first social network. By using it you agree to be kind, respect privacy boundaries, and never weaponize screenshots or exports against other members.</p>
        </section>

        <section>
          <h2>2. Accounts & access</h2>
          <ul>
            <li>You must be 16+ and use accurate contact info so we can verify invites.</li>
            <li>You’re responsible for safeguarding your password, 2FA codes, and whatever device you use to spin the writing prompt washing machine.</li>
            <li>We can pause or remove accounts that spam, harass, or otherwise harsh the mellow.</li>
          </ul>
        </section>

        <section>
          <h2>3. Content ownership</h2>
          <p>You own your posts, photos, events, and prompts. You grant us a limited license to store and display them to the friends (and invited guests) you choose so the app works as expected.</p>
        </section>

        <section>
          <h2>4. Guests & events</h2>
          <p>Hosts can invite people without Fun Old Times accounts. We’ll email them on your behalf, track RSVPs, and show them the event info. They can’t see anything else unless they sign up and become friends.</p>
        </section>

        <section>
          <h2>5. Absolutely no ads or AI data grabs</h2>
          <ul>
            <li>No advertising, sponsored posts, or third-party trackers.</li>
            <li>No using your content to train AI models. If we ever consider it, we will explain why and collect an explicit opt-in that only affects future content.</li>
          </ul>
        </section>

        <section>
          <h2>6. Service changes</h2>
          <p>We ship new features often (hello, disco capybara). We may update these terms as we iterate, and we’ll post a notice plus an in-app alert when we do.</p>
        </section>

        <section>
          <h2>7. Liability stuff</h2>
          <p>Fun Old Times is provided “as is.” We aim for 100% uptime but can’t promise it. If something breaks we’ll fix it fast, but we’re not liable for lost data, emotional damage from puns, or missed events.</p>
        </section>

        <section>
          <p class="note">Need clarification? Email support@funoldtimes.com — we read every message, usually with a neon highlighter.</p>
        </section>
      </article>
    `;
  }
}

customElements.define('terms-conditions', TermsConditions);

